<template>
  <div
    class="gl-badge-info"
    :style="{ backgroundColor: hex2rgba(getColorByRiskLevel(value), 0.1) }"
  >
    <GlRiskBadge :value="value" />
    <div
      v-if="$slots.text"
      class="gl-badge-info__text"
    >
      <slot name="text" />
    </div>
    <div
      v-else
      class="gl-badge-info__text"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
// components
import GlRiskBadge from '@/components/risk/gl-risk-badge'
// Utils
import { calculateRiskLevel, getColorByRiskLevel } from '@/utils/risk-formatter'
import { hex2rgba } from '@/utils/cytoskape-ui-rules'

export default {
  name: 'GlBadgeInfo',
  components: {
    GlRiskBadge,
  },
  props: {
    text: {
      type: String,
      default: 'Not Identified',
    },
    value: {
      type: [String, Number],
      default: 0,
    },
  },
  methods: {
    hex2rgba,
    calculateRiskLevel,
    getColorByRiskLevel,
  },
}
</script>

<style>
.gl-badge-info {
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  max-width: 100%;
  padding: 2px;
  padding-right: 8px;
  border-radius: 48px;
}
.gl-badge-info__text {
  flex: 0 1 auto;
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  color: var(--Basic-900, #091540);
  font-size: var(--Size-M, 14px);
  font-weight: 500;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
  z-index: 2;
}
</style>
